module.exports = __webpack_public_path__ + "img/image17.c51b11dd.webp";